<script>
    import MobileSearch from "./MobileSearch.svelte";
    import MobilesRemoveInvalid from "./MobilesRemoveInvalid.svelte";
    import {createEventDispatcher} from 'svelte';
    import {convertDate} from './lib/lib';
    import {getMessageReports} from "./requests";
    import app_alert from "./stores/alerts";

    export let sms_id;
    export let showReports = false;

    const dispatch = createEventDispatcher();

    let showMobileSearch = false; // MobileSearch
    let searchMobile = '';
    let message = {
        reports: [],
    };
    let badNumbers = [];
    let totalBadNumbers = 0;
    let report_view = 0;
    let selectedReport = 0;
    let showMobilesRemoveInvalid = false;
    let loaded = false;

    const getReports = async () => {
        totalBadNumbers = 0;

        const [err, res] = await getMessageReports(sms_id);
        message = res;

        message.reports.map(report => {
            if (report.operator === 'Vodafone') {
                report.operator_icon = 'vodafone.png';
            } else if (report.operator === 'Cosmote') {
                report.operator_icon = 'cosmote.png';
            } else if (report.operator === 'Wind') {
                report.operator_icon = 'wind.png';
            }

            if (report.status_code != 7) {
                totalBadNumbers++;
            }
        });

        loaded = true;
    }

    const Close = () => {
        showReports = false;
        message = {
            reports: [],
        };
        dispatch('close', {});
    }

    const openMobileSearch = mobile => {
        selectedReport = mobile;
        searchMobile = mobile;
        showMobileSearch = true;
    }

    const closeMobileSearch = () => {
        searchMobile = '';
        showMobileSearch = false;
    }

    const openMobilesRemoveInvalid = () => {
        badNumbers = [];
        message.reports.map(item => {
            if (item.status_code != 7) {
                badNumbers.push(item.number);
            }
        });
        if (badNumbers.length == 0) {
            app_alert.show("alert", "Δεν βρέθηκαν αριθμοί κινητών για αφαίρεση.");
            return;
        }
        showMobilesRemoveInvalid = true;
    }

    const closeMobilesRemoveInvalid = () => {
        badNumbers = [];
        showMobilesRemoveInvalid = false;
    }


    $: {
        if (showReports) {
            getReports();
        }
    }
</script>

<div class="popup-overlay" class:visible={ showReports }>
    <div class="modal modal-lg">
        <div class="modal-header">
            <div class="modal-title">
                Αναφορές Μηνύματος
            </div>
            <div class="controls-right">
                <span on:click="{ Close }"><i class="fa fa-times"></i></span>
            </div>
        </div>
        <div class="modal-body">
            {#if loaded}
                <table class="table table-report">
                    <tbody>
                    <tr>
                        <td width="50%">Αριθμός μονάδων:</td>
                        <td class="text-info">{ message.total_recipients }</td>
                    </tr>
                    <tr>
                        <td>Αριθμός παραληπτών:</td>
                        <td class="text-info">{ message.total_recipients }</td>
                    </tr>
                    <tr>
                        <td>Αριθμός αναφορών:</td>
                        <td class="text-info">{ message.reports.length }</td>
                    </tr>
                    <tr>
                        <td>Επιτυχής αποστολές:</td>
                        <td class="text-info">{ message.success_deliveries }</td>
                    </tr>
                    <tr>
                        <td>Ποσοστό επιτυχίας:</td>
                        <td class="text-info">{ message.percentage }%</td>
                    </tr>
                    </tbody>
                </table>
                {#if message.reports.length}
                    <div class="row">
                        <div class="col-md-4 col-sm-6">
                            <div class="form-group">
                                <select class="form-control" bind:value="{ report_view }">
                                    <option value="0">Εμφάνιση όλων</option>
                                    <option value="1">Επιτυχής αναφορές</option>
                                    <option value="2">Εσφαλμένες αναφορές</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-8 col-sm-6">
                            <button class="btn btn-primary btn-block" on:click={ openMobilesRemoveInvalid }
                                    disabled="{ totalBadNumbers == 0 }">Αφαίρεση
                                εσφαλμένων αριθμών από ομάδες
                            </button>
                        </div>
                    </div>
                    <p class="text-info text-small">
                        Κλικάρετε πάνω σε οποιαδήποτε γραμμή του πίνακα για να βρείτε σε ποιές ομάδες ή επαφές ανήκει ο
                        αριθμός κινητού.
                    </p>
                    <div class="table-responsive">
                        <table class="table table-bordered table-condensed table-list table-data mrg-b-none">
                            <thead>
                            <tr>
                                <th>Κινητό</th>
                                <th>Ημερομηνία</th>
                                <th>Σφάλμα</th>
                                <th>Κατάσταση</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {#each message.reports as report}
                                {#if (report_view == 0 || (report_view == 1 && report.status_code == 7) || (report_view == 2 && report.status_code != 7)) }
                                    <tr class="pointer" class:selected="{ selectedReport === report.number }"
                                        on:click="{ () => { openMobileSearch(report.number) } }"
                                    >
                                        <td>{ report.number }</td>
                                        <td>{ convertDate(report.status_date) }</td>
                                        <td class="hidden-sm">{ report.error_code > 0 ? report.error_code : '' }</td>
                                        <td>{ report.status_message }</td>
                                        <td class="text-center operator">
                                            {#if report.operator_icon}
                                                <img class="operator-icon"
                                                     src="/assets/images/operators/{ report.operator_icon }"
                                                     title="{ report.operator }">
                                            {:else}
                                                { report.operator }
                                            {/if}
                                        </td>
                                    </tr>
                                {/if}
                            {/each}
                            </tbody>
                        </table>
                    </div>
                {:else}
                    <div class="alert alert-warning">
                        <p>Δεν υπάρχουν αναφορές για αυτό το μήνυμα προς το παρόν.</p>
                    </div>
                {/if}
            {:else}
                <p class="text-center">
                    Ανάκτηση αναφορών
                </p>
            {/if}
        </div>
    </div>
</div>

<MobileSearch showMobileSearch="{ showMobileSearch }" mobile="{ searchMobile }" on:close="{ closeMobileSearch }"/>
{#if showMobilesRemoveInvalid}
    <MobilesRemoveInvalid {badNumbers} closeCallback="{ closeMobilesRemoveInvalid  }"/>
{/if}

<style>
    .operator-icon {
        width: 16px;
        height: 16px;
    }

    @media (min-width: 768px) {
        .table-list > tbody > tr {
            position: relative;
        }

        .table-list > tbody > tr > td {
            position: unset;
        }

        .operator {
            padding: 0;
        }

        .operator-icon {
            position: absolute;
            top: 6px;
            right: 10px;
        }
    }
</style>
